import React from 'react';

interface Props {
  height?: number;
  width?: number;
}
function LeftChevron({ height = 15, width = 15 }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none">
      <path
        d="M9.375 3.75L5.625 7.5L9.375 11.25"
        stroke="#17385D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default LeftChevron;
